'use client'

import { useMemo } from 'react'
import { useSellerId } from '@/hooks/useSellerId'
import { useCurrentUser } from '@/hooks/useCurrentUser'

export function useIsOwner() {
  const {
    sellerId,
    loading: sellerLoading,
  } = useSellerId()

  const {
    userId,
    isLoading: userLoading,
  } = useCurrentUser()

  const isOwner =
    useMemo(() => {
      const currentUserId =
        Number(userId || 0)

      const currentSellerId =
        Number(sellerId || 0)

      if (
        !currentUserId ||
        !currentSellerId
      ) {
        return false
      }

      return (
        currentUserId ===
        currentSellerId
      )
    }, [
      userId,
      sellerId,
    ])

  return {
    isOwner,
    isLoading:
      userLoading ||
      sellerLoading,
  }
}